module.exports = __webpack_public_path__ + "img/main_bt_anipang2.d6c340cc.png";